import { DescribeNodeType } from '~/scenes/Automation/Flows/Actions/util/descriptionStandards';

const describeAppVBOWaardecheckAppraisalRequestNewCondition =
  (): DescribeNodeType =>
    'een nieuwe Avix waardecheck - waardebepaling is aangevraagd';

export default describeAppVBOWaardecheckAppraisalRequestNewCondition;
